/* eslint-disable global-require */
import chroma from 'chroma-js';
import Icon from '../../../components/common/Icon';
import {Platform} from 'react-native';

const colors = {
  backgroundColor: '#fbfbfb',
  dashboardBackgroundColor: 'rgb(238, 238, 238)',
  primaryColor: '#5BC3DF',
  secondaryColor: '#f00976',
  tertiaryColor: '#1784E9',
  fourthColor: 'rgb(248,218,100)',
  fifthColor: '#F5A623',
  neutralColor: 'rgb(155, 155, 155)',
  overPrimaryColor: 'white',
  overSecondaryColor: 'white',
  gray: {
    normal: '#4a4a4a',
    normalLight: '#9b9b9b',
    light: '#ddd',
    lightBackground: '#f5f5f5',
    selectedBackground: 'rgb(238, 238, 238)',
  },
  white: '#FFFFFF',
  errorColor: 'red',
  overErrorColor: 'white',
  errorBackgroundColor: '#FCEBED',
  passwordStrength: {
    error: '#dc143c',
    warning: '#c0f149',
    notice: '#a8f070',
    ok: '#90ee90',
  },
};

const inferredColors = {
  overPrimaryColorWithLessImpedance: chroma(colors.overPrimaryColor)
    .alpha(0.53)
    .css(),
  transparentPrimaryColor: chroma(colors.primaryColor)
    .alpha(0.6)
    .css(),
  transparentOverPrimaryColor: chroma(colors.overPrimaryColor)
    .alpha(0.6)
    .css(),
  transparentSecondaryColor: chroma(colors.secondaryColor)
    .alpha(0.6)
    .css(),
  veryTransparentSecondaryColor: chroma(colors.secondaryColor)
    .alpha(0.2)
    .css(),
};

const ui = {
  IconComponent: Icon,
  buttons: {
    PRIMARY: {
      backgroundColors: [colors.primaryColor, colors.primaryColor, colors.primaryColor],
      textColor: colors.white,
    },
    SECONDARY: {
      backgroundColor: colors.secondaryColor,
      borderColor: colors.secondaryColor,
      textColor: colors.white,
    },
    TERTIARY: {
      backgroundColor: colors.white,
      borderColor: colors.tertiaryColor,
      textColor: colors.tertiaryColor,
    },
    LINK: {
      hasRightArrow: true,
      color: colors.primaryColor,
    },
    SUCCESS: {
      backgroundColors: [colors.primaryColor, colors.primaryColor, colors.primaryColor],
      textColor: colors.white,
    },
    DEFAULT: {
      backgroundColors: [colors.white, colors.white, colors.white],
      borderColor: '#ABABAB',
      textColor: '#ABABAB',
    },
    CANCEL: {
      backgroundColors: [colors.secondaryColor, colors.secondaryColor, colors.secondaryColor],
      borderColor: colors.secondaryColor,
      textColor: colors.white,
    },
    borderRadius: 0,
  },
  colors: {
    background: 'rgb(238, 238, 238)',
    black: '#000000',
    frame: {
      backgroundColor: colors.white,
      textColor: colors.gray.normal,
      linkColor: colors.primaryColor,
    },
    gray: {
      dark: 'gray',
      light: '#ddd',
      normal: '#4a4a4a',
    },
    neutral: '#f00976',
    primary: {
      dark: '#5BC3DF',
      light: '#5BC3DF',
      normal: '#5BC3DF',
    },
    secondary: {
      dark: '#f00976',
      light: '#f00976',
      normal: '#f00976',
    },
    status: {
      disabled: '#4a4a4a',
      error: 'red',
      success: '#90ee90',
      warning: '#c0f149',
    },
    transparent: 'transparent',
    white: '#FFFFFF',
  },
  font: {
    family: 'Lato',
    size: {
      large: 18,
      medium: 16,
      regular: 14,
      small: 12,
      xLarge: 20,
      xSmall: 10,
    },
    weight: {
      bold: '600',
      light: '300',
      normal: '500',
    },
  },
  icons: {
    arrowRight: 'arrow-right',
  },
  spacing: {
    unit: 8,
  },
};

export default {
  name: 'triPica',
  ...colors,
  ...inferredColors,
  frame: {
    backgroundColor: colors.white,
    textColor: colors.gray.normal,
    linkColor: colors.primaryColor,
  },
  brandIcon: require('./img/brand_icon.png'),
  footerImage: require('./img/footer.png'),
  voucherImage: require('./img/voucher_bg.jpg'),
  wellDoneImage: require('./img/well_done.png'),
  noPendingImage: require('./img/no_pending_delivery.png'),
  swapSimImage: require('./img/swap_sim_card.png'),
  simCardOnItsWayImage: require('./img/sim_card_on_its_way.png'),
  inactiveSimCardImage: require('./img/inactive_sim.png'),
  inviteAFriend: require('./img/invite_a_friend.png'),
  invalidInviteAFriend: require('./img/invalid_invite_a_friend.png'),
  logoImage: require('./img/logo.png'),
  selfieImage: require('./img/selfie_shape.png'),
  onboardingImages: [
    require('./img/onboarding_screen_1.png'),
    require('./img/onboarding_screen_2.png'),
    require('./img/onboarding_screen_3.png'),
    require('./img/onboarding_screen_4.png'),
  ],
  successPhoneImage: require('./img/success_phone.png'),
  failurePhoneImage: require('./img/failure_phone.png'),
  orderFailedImage: require('./img/icon_order_failed.png'),
  lostAndStolenImage: require('./img/lost_and_stolen.png'),
  simReplacementImage: require('./img/sim_replacement.png'),
  terminationImage: require('./img/termination.png'),
  lineTerminationSuccessImage: require('./img/line_termination_success.png'),
  paypalVerticalImage: require('./img/paypal_vertical.jpg'),
  paypalMinimalImage: require('./img/paypal_minimal.png'),
  addPaymentMethod: require('./img/add_payment_method.png'),
  requiredToSignUp: {
    creditcard: { useIcon: true, image: require('./img/creditcard.png') },
    phone: { useIcon: true, image: require('./img/phone.png') },
    user: { useIcon: true, image: require('./img/user.png') },
  },
  checkboxColor: colors.gray.normal,
  selectedCheckboxColor: colors.secondaryColor,
  clearButtonColor: '#DDDDDD',
  emptyInboxColor: colors.gray.light,
  emptyTextColor: colors.gray.normalLight,
  textOverColoredBackground: colors.overPrimaryColor,
  secondaryButtonColor: inferredColors.transparentPrimaryColor,
  androidStatusBarColor: colors.primaryColor,
  dashboardStatusBarStyle: 'light-content',
  signUpStatusBarStyle: 'dark-content',
  welcomeScreenStatusBarStyle: 'light-content',
  welcomeScreenTextColor: colors.primaryColor,
  headerBackgroundColor: colors.primaryColor,
  dashboardHeaderTextColor: colors.overPrimaryColor,
  headerTextColor: colors.primaryColor,
  internationalPullToRefreshColor: colors.errorColor,
  internationalRoamingButtonColor: colors.primaryColor,
  internationalRoamLikeHomeButtonColor: colors.secondaryColor,
  internationalIddButtonColor: colors.fifthColor,
  internationalRoamingTitleColor: colors.primaryColor,
  internationalIconColor: colors.overPrimaryColor,
  manageLinesTextColor: colors.gray.normal,
  modeOffNoSubscription: colors.errorColor,
  signUpPoweredByColor: colors.gray.normalLight,
  signUpTextColor: colors.primaryColor,
  signUpDarkTextColor: colors.gray.normal,
  signUpLightIconColor: colors.gray.normalLight,
  signUpInputTextColor: colors.secondaryColor,
  signUpTextAreaBackgroundColor: inferredColors.veryTransparentSecondaryColor,
  signUpTextAreaPlaceholderColor: inferredColors.transparentSecondaryColor,
  signUpTransparentInputTextColor: inferredColors.transparentSecondaryColor,
  signUpFocusedInputTextColor: colors.secondaryColor,
  signUpTransparentTextColor: inferredColors.transparentPrimaryColor,
  signUpPlaceholderColor: colors.gray.normalWithLessOpacity,
  signUpUnselectedInputBorderColor: colors.gray.normalWithLessOpacity,
  signUpIconInCircleColor: colors.overPrimaryColor,
  signUpIconInCircleBackgroundColor: colors.primaryColor,
  signUpIconColor: colors.primaryColor,
  signUpPhonePicker: colors.gray.normal,
  signUpDeliveryMethodChoice: colors.secondaryColor,
  signUpSelectedDeliveryMethodChoice: colors.secondaryColor,
  signUpEditPlan: colors.secondaryColor,
  signUpPDPALinkColor: colors.secondaryColor,
  androidInputSelectionColor: inferredColors.secondaryColor,
  iosInputSelectionColor: colors.secondaryColor,
  transparentIconColor: inferredColors.transparentPrimaryColor,
  digitsInputColor: colors.secondaryColor,
  walletColor: '#eeeeee',
  earthColor: colors.fifthColor,
  roamingIconColor: colors.primaryColor,
  slidersColor: colors.secondaryColor,
  bottomPanelColor: '#ffffff50',
  bottomPanelBorderColor: colors.gray.light,
  gradientColorsPage: [colors.white, colors.white],
  textInput: {
    underlineColor: colors.secondaryColor,
    textColor: colors.secondaryColor,
    placeholderColor: colors.gray.normalLight,
    disabled: {
      underlineColor: colors.white,
      textColor: colors.secondaryColor,
    },
  },
  pageTitle: {
    titleColor: colors.primaryColor,
  },
  choosePlan: {
    serviceOption: {
      priceColor: colors.gray.normalLight,
      selectedPriceColor: colors.primaryColor,
      titleColor: colors.secondaryColor,
      selectedTitleColor: colors.secondaryColor,
      legendColor: colors.secondaryColor,
      selectedLegendColor: colors.secondaryColor,
    },
    footer: {
      labelColor: colors.primaryColor,
      priceColor: colors.primaryColor,
    },
  },
  profile: {
    iconColor: colors.secondaryColor,
  },
  payments: {
    subtitle: {
      color: colors.secondaryColor,
      fontSize: 13,
    },
    meanIcon: {
      color: colors.secondaryColor,
    },
  },
  manageLines: {
    textColor: colors.secondaryColor,
    iconColor: colors.secondaryColor,
    arrowColor: colors.primaryColor,
  },
  contracts: {
    textColor: colors.primaryColor,
    arrowColor: colors.primaryColor,
  },
  pendingDashboard: {
    menuIcon: {
      color: colors.secondaryColor,
    },
  },
  legalBlurb: {
    textColor: colors.secondaryColor,
  },
  topUp: {
    header: {
      iconColor: colors.primaryColor,
      backgroundColor: colors.eighthColor,
    },
  },
  listFooterArrow: {
    color: colors.primaryColor,
  },
  errorToast: {
    background: colors.errorBackgroundColor,
    iconAndType: colors.errorColor,
    text: colors.gray.normal,
  },
  messageToast: {
    background: colors.white,
    iconAndType: colors.secondaryColor,
    text: colors.gray.normal,
  },
  gradientColors: {
    PRIMARY: [colors.primaryColor, colors.primaryColor, colors.primaryColor],
    SECONDARY: [colors.tertiaryColor, colors.tertiaryColor, colors.tertiaryColor],
  },
  buttons: {
    PRIMARY: {
      backgroundColors: [colors.primaryColor, colors.primaryColor, colors.primaryColor],
      textColor: colors.white,
    },
    SECONDARY: {
      backgroundColor: colors.overPrimaryColor,
      borderColor: colors.primaryColor,
      textColor: colors.primaryColor,
    },
    TERTIARY: {
      backgroundColor: colors.white,
      borderColor: colors.tertiaryColor,
      textColor: colors.tertiaryColor,
    },
    SUCCESS: {
      backgroundColors: [colors.primaryColor, colors.primaryColor, colors.primaryColor],
      textColor: colors.white,
    },
    DEFAULT: {
      backgroundColors: [colors.white, colors.white, colors.white],
      borderColor: '#ABABAB',
      textColor: '#ABABAB',
    },
    CANCEL: {
      backgroundColors: [colors.secondaryColor, colors.secondaryColor, colors.secondaryColor],
      borderColor: colors.secondaryColor,
      textColor: colors.white,
    },
    borderRadius: 3,
  },
  roaming: {
    textColor: colors.gray.normal,
    notFoundTextColor: colors.gray.normalLight,
  },
  onboarding: {
    fullscreenImages: false,
    bulletPointColor: colors.primaryColor,
    chosenBulletColor: colors.primaryColor,
    textColor: colors.primaryColor,
    skipButtonTextColor: colors.primaryColor,
  },
  usages: {
    FACEBOOK_DATA_CREDIT: {
      icon: 'facebook-logo',
      iconColor: colors.secondaryColor,
      borderColor: '#EA39C4',
      textColor: colors.secondaryColor,
      gradientColors: ['#F50778', '#EA39C4'],
    },
    YOUTUBE_DATA_CREDIT: {
      icon: 'youtube',
      iconColor: colors.secondaryColor,
      borderColor: '#EA39C4',
      textColor: colors.secondaryColor,
      gradientColors: ['#F50778', '#EA39C4'],
    },
    INSTAGRAM_DATA_CREDIT: {
      icon: 'instagram',
      iconColor: colors.secondaryColor,
      borderColor: '#EA39C4',
      textColor: colors.secondaryColor,
      gradientColors: ['#F50778', '#EA39C4'],
    },
    VOICE_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: '#5BC3DF',
      textColor: colors.secondaryColor,
      gradientColors: ['#1784E9', '#44BBE1', '#5BC3DF'],
    },
    SMS_CREDIT: {
      icon: 'sms',
      iconColor: colors.secondaryColor,
      borderColor: '#F7C269',
      textColor: colors.secondaryColor,
      gradientColors: ['#FBE66A', '#F7C269'],
    },
    DATA_CREDIT: {
      icon: 'data',
      iconColor: colors.secondaryColor,
      borderColor: '#EA39C4',
      textColor: colors.secondaryColor,
      gradientColors: ['#F50778', '#EA39C4'],
    },
    ROA_VOICE_RDM1_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: colors.primaryColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#1784E9', '#44BBE1', '#5BC3DF'],
    },
    ROA_SMS_RDM1_CREDIT: {
      icon: 'sms',
      iconColor: colors.secondaryColor,
      borderColor: colors.primaryColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#FBE66A', '#F7C269'],
    },
    ROA_DATA_RDM1_CREDIT: {
      icon: 'data',
      iconColor: colors.secondaryColor,
      borderColor: colors.primaryColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#F50778', '#EA39C4'],
    },
    ROA_VOICE_RDM2_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: colors.primaryColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#1784E9', '#44BBE1', '#5BC3DF'],
    },
    ROA_SMS_RDM2_CREDIT: {
      icon: 'sms',
      iconColor: colors.secondaryColor,
      borderColor: colors.primaryColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#FBE66A', '#F7C269'],
    },
    ROA_DATA_RDM2_CREDIT: {
      icon: 'data',
      iconColor: colors.secondaryColor,
      borderColor: colors.primaryColor,
      textColor: colors.secondaryColor,
      gradientColors: ['#F50778', '#EA39C4'],
    },
    IDDVOICEA_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: '#5BC3DF',
      textColor: colors.secondaryColor,
      gradientColors: ['#1784E9', '#44BBE1', '#5BC3DF'],
    },
    IDDVOICEB_CREDIT: {
      icon: 'phone',
      iconColor: colors.secondaryColor,
      borderColor: '#5BC3DF',
      textColor: colors.secondaryColor,
      gradientColors: ['#1784E9', '#44BBE1', '#5BC3DF'],
    },
    IDDSMSA_CREDIT: {
      icon: 'sms',
      iconColor: colors.secondaryColor,
      borderColor: '#F7C269',
      textColor: colors.secondaryColor,
      gradientColors: ['#FBE66A', '#F7C269'],
    },
    IDDSMSB_CREDIT: {
      icon: 'sms',
      iconColor: colors.secondaryColor,
      borderColor: '#F7C269',
      textColor: colors.secondaryColor,
      gradientColors: ['#FBE66A', '#F7C269'],
    },
    DEFAULT: {
      icon: 'star',
      iconColor: colors.secondaryColor,
      borderColor: '#D445DA',
      textColor: colors.secondaryColor,
      gradientColors: ['#E445EA', '#C548FE'],
    },
  },
  catalog: {
    TO_ZONED_VOICE: {
      icon: 'phone-plane',
      color: colors.secondaryColor,
    },
    VOICE: {
      icon: 'phone',
      color: colors.secondaryColor,
    },
    SMS: {
      icon: 'sms',
      color: colors.secondaryColor,
    },
    DATA: {
      icon: 'data',
      color: colors.secondaryColor,
    },
    ROA_DATA: {
      icon: 'international',
      color: colors.secondaryColor,
    },
    EXTRA: {
      icon: 'attach-money',
      color: colors.fourthColor,
    },
    DEFAULT: {
      icon: 'star',
      color: colors.fourthColor,
    },
  },
  IAPPackages: {
    EXTRA: {
      icon: 'payment',
      colors: ['#FF9748', '#FFAC35', '#FDF563'],
      preventIconReversal: true,
    },
    ROAM_LIKE_HOME: {
      icon: 'paper-plane',
      colors: ['#EA39C4', '#EA39C4', '#EA39C4'],
    },
    ROAMING_PACKAGE: {
      icon: 'suitcase',
      colors: ['#1784E9', '#44BBE1', '#5BC3DF'],
    },
  },
  orders: {
    SIGNUP: {
      icon: 'registdone',
      color: '#D445DA',
      reverse: true,
    },
    CHANGEPLAN: {
      icon: 'refresh',
      color: '#F7C269',
    },
    VOUCHER: {
      icon: 'voucher',
      color: '#D445DA',
    },
    TOPUP: {
      icon: 'plus',
      color: '#5BC3DF',
    },
    SN3: {
      icon: 'plus',
      color: '#19ba44',
    },
    ACT: {
      icon: 'plus',
      color: '#19ba44',
    },
  },
  timelineItems: {
    ACTIVATION_PAYMENT_KO: {
      icon: 'error',
      color: '#D445DA',
    },
    CHANGE_LINE_MODE_OFF: {
      icon: 'toggle-off',
      color: '#5BC3DF',
      reverse: true,
    },
    CHANGE_LINE_MODE_ON: {
      icon: 'toggle-on',
      color: '#5BC3DF',
      reverse: true,
    },
    CHANGEPLAN_OK: {
      icon: 'upgrade-simcard',
      color: '#F7C269',
    },
    CHANGEPLAN_CANCELED: {
      icon: 'upgrade-simcard',
      color: '#F7C269',
    },
    CHANGEPLAN_SCHEDULED: {
      icon: 'upgrade-simcard',
      color: '#F7C269',
    },
    CHANGEPLAN_FUTURE_CANCEL: {
      icon: 'upgrade-simcard',
      color: '#F7C269',
    },
    PAYMENT_MEAN_REGISTRATION: {
      icon: 'payment',
      color: '#D445DA',
    },
    PAYMENT_MEAN_PATCHED: {
      icon: 'payment',
      color: '#D445DA',
    },
    REGISTRATION_OK: {
      icon: 'registdone',
      color: '#D445DA',
      reverse: true,
    },
    TOPUP_OK: {
      icon: 'topupdone',
      color: '#5BC3DF',
    },
    TOPUP_KO: {
      icon: 'error',
      color: '#5BC3DF',
    },
    TICKET_UPDATED: {
      icon: 'helpticketanswered',
      color: '#5BC3DF',
      reverse: true,
    },
    TICKET_CREATED: {
      icon: 'helpticket',
      color: '#5BC3DF',
      reverse: true,
    },
    MODEOFF_OK: {
      icon: 'refresh',
      color: '#5BC3DF',
    },
    RENEWAL_OK: {
      icon: 'refresh',
      color: '#D445DA',
    },
    VOUCHER_KO: {
      icon: 'voucher',
      color: '#5BC3DF',
    },
    VOUCHER_OK: {
      icon: 'voucher',
      color: '#D445DA',
    },
    RESET_PASSWORD_DONE: {
      icon: 'password',
      color: '#D445DA',
    },
    RESET_PASSWORD_ASK: {
      icon: 'user',
      color: '#5BC3DF',
    },
    CUSTOMER_CREATION: {
      icon: 'user',
      color: '#D445DA',
    },
    CHANGE_PASSWORD: {
      icon: 'password',
      color: '#5BC3DF',
    },
    CHANGE_PERSONAL_INFO: {
      icon: 'edit',
      color: '#5BC3DF',
      reverse: true,
    },
    ACTIVATION_OK: {
      icon: 'simcard',
      color: '#D445DA',
    },
    ACTIVATION_BONUS_WALLET_CREDIT_OK: {
      icon: 'wallet',
      color: '#D445DA',
    },
    WALLET_CREDIT_KO: {
      icon: 'error',
      color: '#D445DA',
    },
    WALLET_CREDIT_OK: {
      icon: 'wallet',
      color: '#D445DA',
    },
    GOODWILL_OK: {
      icon: 'wallet',
      color: '#D445DA',
    },
    GODCHILD_WALLET_CREDIT_OK: {
      icon: 'invitefriend',
      color: '#5BC3DF',
    },
    GODFATHER_WALLET_CREDIT_OK: {
      icon: 'invitefriend',
      color: '#5BC3DF',
    },
    DELIVERY_OK: {
      icon: 'simcard',
      color: '#D445DA',
    },
    DELIVERY_PREMIUM_OK: {
      icon: 'simcard',
      color: '#D445DA',
    },
    PORTA_REJECTED: {
      icon: 'error',
      color: '#D445DA',
    },
    PORTA_ACTIVATION_OK: {
      icon: 'simcard',
      color: '#D445DA',
    },
    PORTA_PAYMENT_KO: {
      icon: 'error',
      color: '#D445DA',
    },
    SUSPENSION_BY_AGENT_OK: {
      icon: 'simcard',
      color: '#D445DA',
    },
    SUSPENSION_BY_CUSTOMER_OK: {
      icon: 'simcard',
      color: '#D445DA',
    },
    TERMINATION_OK: {
      icon: 'simcard',
      color: '#D445DA',
    },
    REACTIVATION_OK: {
      icon: 'simcard',
      color: '#D445DA',
    },
    SIM_SWAP_OK: {
      icon: 'simcard',
      color: '#D445DA',
    },
  },
  doughnutConfig: {
    standardDoughnut: [
      'FACEBOOK_DATA_CREDIT',
      'YOUTUBE_DATA_CREDIT',
      'INSTAGRAM_DATA_CREDIT',
      'DATA_CREDIT',
      'VOICE_CREDIT',
      'SMS_CREDIT',
    ],
    iddDoughnut: ['IDDVOICEA_CREDIT', 'IDDSMSA_CREDIT', 'IDDVOICEB_CREDIT', 'IDDSMSB_CREDIT'],
    extraCreditDoughnut: [],
  },
  defaultFeedback: '#eeeeee',
  fontFamily: 'Lato',
  ui,
};
